import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuList } from './navigation-drawer.constant';
@Component({
  selector: 'app-navigation-drawer-case1',
  templateUrl: './navigation-drawer-case1.component.html'
})
export class NavigationDrawerCase1Component implements OnInit{
  isShowMenubar = false;
  isShowCascadebar = false;
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];
  menuList = MenuList;
  cascadeMenus: any[] = [];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  title = 'Welcome';
  subTitle = 'Overline';
  backUrl = '/button';
  logoUrl = '/';
  logo = '../../assets/images/logo-mee-black-mac.svg';
  smallLogo = '../../assets/images/logo.svg';
  logoAltText = 'Macmillan Education Everywhere Platform';
  moreMenuTitle = 'More';
  ariaLabels: any = {
    backButtonAriaLabel: "Back",
    closeButtonAriaLabel: "Close",
    hamburgerAriaLabel: "Menu",
    logoIcon: "Logo"
  };
  activeHamburger = false as boolean;
  currentUrl: string;
  buttonType = 'button' as string;
  buttonId = 'hamburgerIcon' as string;
  buttonValue = 'hamburger' as string;
  cascadeMenubarLabel = 'Back' as string;
  isBrowser:boolean;
  dummyId6: string = 'dummyId6';
  dummyId7: string = 'dummyId7';
  alreadyTriggered=false;
  list = [
    { key: "Start Date", value: "21/05/20" },
    { key: "End Date", value: "22/06/20" },
  ];


  constructor(private activRoute: ActivatedRoute, @Inject(PLATFORM_ID) public platformId: Object) {
    this.currentUrl = './';
    if (!isPlatformBrowser(platformId)) {
      this.isShowMenubar = true;
      this.isBrowser = false;
    }else{
      this.isBrowser = true;
      const windowWidth = window.innerWidth;
      if((windowWidth > 1024)){
        this.isShowMenubar = true;
      }
    }
    this.prepareNoJsParamsInCascade(this.menuList);
  }
  
  @HostListener('window:resize', ['$event'])
  onResize() {
    const windowWidth = window.innerWidth;
      this.isShowMenubar = windowWidth > 1023? true: false;
  }
  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: any) {
    let value:any = document.getElementsByClassName('c-menu__list-item-link--is-selected');
    if (value) {
      let minvalue
      if (value.length >= 2 && this.cascadeMenus.length >= 2) {
        if ((this.cascadeMenus.length >= 2) && (value.length <= 2 || value.length === this.cascadeMenus.length)) {
          minvalue = 1;
        } else if(value.length > this.cascadeMenus.length){
          minvalue = 2;
        }else {
          minvalue = this.cascadeMenus.length
        }
        value[value.length - minvalue].focus();
      } else {
        value[0]?.focus();
      }
      this.onClickCascadeBack(value.length);
    }
  }

  isMobileWidth() {
    if (isPlatformBrowser(this.platformId)) {
      return window?.innerWidth < 1023
    }
    else {
      return false;
    }
  }
  
  prepareNoJsParamsInCascade(listItems: any) {
    if (listItems?.length > 0) {
      listItems.forEach((val: any, index: number) => {
        this.appendUrlCheckSelected(val, index);
        if (val.children?.length > 0) {
          this.prepareNoJsParamsInCascade(val.children);
        }
      });
    }
  }
  appendUrlCheckSelected(val: any, index: number) {
    if (!isPlatformBrowser(this.platformId) && val.isContainSubMenu && !val.url) {
      val.url = './';
      val.queryParams = { 'menuHierarchy': val.hierarchyLevel };
    }
    if (val.url === this.activRoute.snapshot.url[0].path) {
      val.active = true;
      val.selected = false;
    }
  }
  getMenuItem(navItems: any, hierarchyLevel: any) {
    let item: any = {};
    if (navItems[hierarchyLevel[1]] && navItems[hierarchyLevel[0]].children) {
      let childItems = navItems[hierarchyLevel[0]].children;
      hierarchyLevel.splice(0, 1);
      item = this.getMenuItem(childItems, hierarchyLevel);
    } else {
      item = navItems[hierarchyLevel[0]];
    }
    return item;
  }
  ngOnInit(): void {
    this.activRoute.queryParams.subscribe((param: any) => {
      this.cascadeMenus = [];
      let hierarchyLevel = this.activRoute.snapshot.queryParams?.menuHierarchy?.split('_') || [];
      if (!isPlatformBrowser(this.platformId) && this.activRoute.snapshot.queryParams?.menuHierarchy) {
        if (hierarchyLevel.length > 1) {
          let item = this.getMenuItem(this.menuList, hierarchyLevel);
          if (item) {
            item.children?.forEach((val: any) => {
              if (val.url?.includes(this.activRoute.snapshot.url[0].path)) {
                val.active = true;
              } else {
                val.active = false;
              }
              val.selected = false;
            })
            this.cascadeMenus.push({
              name: 'Menu',
              isVisible: true,
              menus: item.children
            });
            this.isShowCascadebar = true;
            this.isShowMenubar = false;
          }
        } else {
          this.cascadeMenus.push({
            name: '',
            isVisible: true,
            menus: this.menuList.find((val: any) => val.hierarchyLevel === hierarchyLevel[0])?.children
          });

        }
        this.isShowCascadebar = true;
        this.isShowMenubar = true;
        if (!isPlatformBrowser(this.platformId)) {
          this.isShowCascadebar = true;
          this.isShowMenubar = false;
        }
      }
    })
  }
  onCloseMenubar() {
    this.isShowMenubar = false;
    this.menuList.forEach((obj: any) => obj.active = false);
  }
  onClickMenu(menu: any) {
    this.cascadeMenus = [];
    this.breadcrumbsName = [];
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.isShowCascadebar = true;
      this.isShowMenubar = false;
    } else {
      this.isShowCascadebar = true;
    }
    if (menu.isContainSubMenu) {
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: menu.children
      });
    }
    this.menuList.forEach((obj: any) => {
      if (obj.id === menu.id) {
        if (obj.url) {
          obj.active = true;
        } else {
          obj.selected = true;
        }
      } else {
        // obj.active = false;
        obj.selected = false;

      }
      if (obj.id === menu.id) {
        obj.active = true;
      } else {
        obj.active = false;
      }
      return obj;
    });
  }
  onClickMoreMenu() {
    this.onClickCascadeClose();
  }
  onClickCascadeMenu(menu: any, index: number) {
    this.cascadeMenus.splice(index + 1, this.cascadeMenus.length - (index + 1));
    if (menu.isContainSubMenu) {
      this.displayBreadcrumbs(menu);
      this.cascadeMenus.push({
        name: menu.name,
        isVisible: true,
        menus: menu.children
      });
    }
    this.cascadeMenus.forEach((parentObj: any, i: number) => {
      const windowWidth = window.innerWidth;
      if (windowWidth < 1023) {
        if (i <= index && menu.isContainSubMenu) {
          parentObj.isVisible = false;
        }
      }
      if (i > index) {
        parentObj.menus.forEach((obj: any) => obj.active = false);
      } else if (i === index) {
        parentObj.menus.forEach((obj: any) => {
          if (obj.id === menu.id) {
            if (obj.url) {
              obj.active = true;
            } else {
              obj.selected = true;
            }
          } else {
            // obj.active = false;
            obj.selected = false;

          }
          if (obj.id === menu.id) {
            obj.active = true;
          } else {
            obj.active = false;
          }
          return obj;
        });
      }
    });
  }
  onClickCascadeBack(index: number) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      this.cascadeMenus.splice(index, 1);
      this.breadcrumbsName.splice(index - 1, 1);
      this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      if (this.cascadeMenus.length > 0) {
        this.cascadeMenus[this.cascadeMenus.length - 1].isVisible = true;
      }
    } else {
      this.cascadeMenus.splice(this.cascadeMenus.length - 1, 1);
    }
    if (this.cascadeMenus.length === 0) {
      this.onClickCascadeClose();
    }
  }
  onClickCascadeClose() {
    this.isShowCascadebar = false;
    this.isShowMenubar = true;
    this.menuList.forEach((obj: any) => obj.active = false);
  }
  hasTitleBar(index: number) {
    if (isPlatformBrowser(this.platformId)) {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      return true;
    } else if (index > 0) {
      return false;
    } else {
      return false;
    }
  }else {
    return false;
  }
  }
  hasBreadcrumbs() {
    // In future we need to implement Logical conditions
    return false;
  }
  displayBreadcrumbs(menu: any) {
    if (menu && menu.name) {
      if (this.breadcrumbsName.length) {
        let breadcrumbsData = this.breadcrumbsName.find(data => data.name === menu.name);
        if (!breadcrumbsData) {
          this.breadcrumbsName.push({
            id: menu.id,
            name: menu.name,
            label: menu.name
          })
          this.numberOfLinksVisible = this.breadcrumbsName.length - 1
        }
      } else {
        this.breadcrumbsName.push({
          id: menu.id,
          name: menu.name,
          label: menu.name
        })
        this.numberOfLinksVisible = this.breadcrumbsName.length - 1
      }
    }
  }
  getBackQueryParam(cascadeMenu: any) {
    return { menuHierarchy: cascadeMenu.hierarchyLevel?.splice(-1, 1) }
  }
  openMenu() {
    if (!this.isShowMenubar && !this.isShowCascadebar) {
      this.isShowMenubar = true;
    } else {
      this.isShowMenubar = false;
      this.isShowCascadebar = false;
    }
  }
}